export default __webpack_public_path__ + "static/media/logotype-blue.82a53959.svg";